
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"data-browser-list.empty.search":"Ihre Suche ergab keine Ergebnisse.","data-browser-list.empty.no-suitable-attributes-found":"Keine geeigneten Attribute verfügbar","data-browser-list.add-more-data":"Weitere Daten hinzufügen"},"en":{"data-browser-list.empty.search":"Your search did not return any results.","data-browser-list.empty.no-suitable-attributes-found":"No matching attributes found","data-browser-list.add-more-data":"Add more data"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();